/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalSystemAccess
 */
export interface ExternalSystemAccess {
    /**
     * 
     * @type {string}
     * @memberof ExternalSystemAccess
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalSystemAccess
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalSystemAccess
     */
    accessType: ExternalSystemAccessAccessTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalSystemAccess
     */
    externalSystemName: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalSystemAccess
     */
    externalSystemVersion: string;
    /**
     * 
     * @type {Date}
     * @memberof ExternalSystemAccess
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ExternalSystemAccess
     */
    fetchType?: ExternalSystemAccessFetchTypeEnum;
}

export function ExternalSystemAccessFromJSON(json: any): ExternalSystemAccess {
    return ExternalSystemAccessFromJSONTyped(json, false);
}

export function ExternalSystemAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalSystemAccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'accessType': json['access_type'],
        'externalSystemName': json['external_system_name'],
        'externalSystemVersion': json['external_system_version'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'fetchType': !exists(json, 'fetch_type') ? undefined : json['fetch_type'],
    };
}

export function ExternalSystemAccessToJSON(value?: ExternalSystemAccess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'access_type': value.accessType,
        'external_system_name': value.externalSystemName,
        'external_system_version': value.externalSystemVersion,
        'fetch_type': value.fetchType,
    };
}

/**
* @export
* @enum {string}
*/
export enum ExternalSystemAccessAccessTypeEnum {
    BasicAuth = 'basic_auth',
    Oauth2 = 'oauth2',
    CertIp = 'cert_ip'
}
/**
* @export
* @enum {string}
*/
export enum ExternalSystemAccessFetchTypeEnum {
    PASSIVE = 'PASSIVE',
    ACTIVE = 'ACTIVE'
}


